import type { ReactNode } from 'react'

import { cn } from './cn'

export interface PageContainerProps {
  readonly children: ReactNode
  readonly className?: string
}

/**
 * A page's content column: centered, at most 1600px, with the mockups' page padding. A `div`,
 * not the mockup's `main`, because the shell already renders the page inside `main`; `w-full`
 * because that `main` is a flex column, where auto margins would otherwise shrink it.
 */
export function PageContainer({ children, className }: PageContainerProps) {
  return (
    <div className={cn('mx-auto w-full max-w-[1600px] px-4 py-8 sm:px-6 lg:py-10', className)}>
      {children}
    </div>
  )
}
